import React from 'react';
import { Alert, AlertProps } from 'react-bootstrap';

interface IAlertDismissableProps {
  style: string,
  show: boolean,
  hideAlert: () => void
};

type AlertDismissableProps = IAlertDismissableProps & AlertProps;

class AlertDismissable extends React.Component<AlertDismissableProps> {
  render() {
    const style = this.props.style === '' ? 'success' : this.props.style;
    return (
      <Alert bsStyle={style} className='alert-dismissable' onDismiss={this.props.hideAlert} hidden={!this.props.show}>
        {this.props.children}
      </Alert>
    );
  }
}

export { AlertDismissable };
